import * as React from "react";
import { getFunctionHandler } from "../../../../constants";
import { CashOutViewRegular } from "./CashOutViewRegular";
import { CashOutViewSuspended } from "./CashOutViewSuspended";
import { Loading } from "./Loading";
import { CashOutViewError } from "./CashOutViewError";
import { CashOutViewConfirmChanges } from "./CashOutViewConfirmChanges";
import { CashOutViewConfirm } from "./CashOutViewConfirm";
import { SportsbookContext } from "../../contexts";
import { getCashOutDisclaimer } from "../../../../helpers";
import { Text } from "@draftkings/arena-web";
const mapCashOutViews = new Proxy({
    Enabled: CashOutViewRegular,
    Suspended: CashOutViewSuspended,
    Processing: Loading,
    Error: CashOutViewError,
    LiveDelay: Loading,
    TraderDelay: Loading,
    NewOffer: CashOutViewConfirmChanges,
    Declined: CashOutViewError,
    Confirm: CashOutViewConfirm,
    Invalid: CashOutViewConfirmChanges,
}, getFunctionHandler);
export const CashOutView = React.memo(function CashOutView(props) {
    const { purchaseId, cashOut, playerBonus } = props;
    const CashOutView = mapCashOutViews[cashOut.status];
    const { dictionary } = React.useContext(SportsbookContext);
    const disclaimer = getCashOutDisclaimer(cashOut, playerBonus, dictionary);
    return React.createElement(React.Fragment, null,
        disclaimer && React.createElement(Text, { testId: `cashout-disclaimer-${purchaseId}`, variant: "notification" }, disclaimer),
        React.createElement(CashOutView, Object.assign({}, cashOut)));
});
//# sourceMappingURL=CashOutView.js.map